// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__l2UCo","rootSmall":"AddTileButton_rootSmall__1Z36p"};